import clsx from 'clsx';
import Link from 'next/link';
import React, { forwardRef, useCallback, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import Spinner from '../spinner';

type LinkWithLoaderProps = Parameters<typeof Link>[0] & {
  spinnerClassName?: string;
};

const LinkWithLoader: React.FC<LinkWithLoaderProps> = forwardRef(({ children, onClick, spinnerClassName, ...props }, ref) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleClick: NonNullable<typeof onClick> = useCallback(
    event => {
      setLoading(true);
      onClick?.(event);
    },
    [onClick],
  );

  return (
    <Link {...props} ref={ref} onClick={handleClick}>
      {loading ? <Spinner className={twMerge(clsx('h-6 animate-spin text-white', spinnerClassName))} /> : children}
    </Link>
  );
});

LinkWithLoader.displayName = 'LinkWithLoader';

export default LinkWithLoader;
